import { render } from "./Breadcrumb.vue?vue&type=template&id=5276c676"
import script from "./Breadcrumb.vue?vue&type=script&lang=js"
export * from "./Breadcrumb.vue?vue&type=script&lang=js"

import "./Breadcrumb.vue?vue&type=style&index=0&id=5276c676&lang=scss"
script.render = render

export default script